import script from "./BuyCoin.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyCoin.vue?vue&type=script&setup=true&lang=js"

import "./BuyCoin.vue?vue&type=style&index=0&id=8ff7b22c&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff7b22c"]])

export default __exports__